var map = {
	"./Clientes/Colegio_mayor_coar_logo.png": 9214,
	"./Clientes/Essalud_Hz.png": 443,
	"./Clientes/La_Panera.png": 3362,
	"./Clientes/Lincuna.png": 2829,
	"./Clientes/contonga.png": 8388,
	"./Clientes/logo_sanpablo_huaraz.png": 8053,
	"./Film_Lavandería_Liz_Rev0.mp4": 7531,
	"./Lavado al agua.jpg": 6817,
	"./Lavado de Terno.jpg": 9081,
	"./Lavado ropa por Kilo.jpg": 4100,
	"./Lavadp zapatillas.jpg": 7814,
	"./Lavanderia .jpg": 1030,
	"./Planchado.jpg": 3965,
	"./Ropa de cama.jpg": 2794,
	"./Ropa de perro.jpg": 6986,
	"./Ropa delicada.jpg": 9498,
	"./aboutLiz.jpg": 2395,
	"./film_banner.mp4": 4680
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4767;